$(document).ready(function() {

    $(document).on('click', '.js-slider-number', function() {
        $('.js-slider-number').removeClass('active');
        $(this).addClass('active');
        $('.b-slider__wrap').fadeIn(300);
    });

    $(document).on('click', '.js-slider-number-first', function() {
        $('.b-slider').addClass('first');
        $('.b-slider').removeClass('second');
        $('.b-slider').removeClass('third');
        $('.js-slider-dot-first').addClass('active');
        $('.js-slider-dot-second').removeClass('active');
        $('.js-slider-dot-third').removeClass('active');
    });
    $(document).on('click', '.js-slider-number-second', function() {
        $('.b-slider').removeClass('first');
        $('.b-slider').addClass('second');
        $('.b-slider').removeClass('third');
        $('.js-slider-dot-first').removeClass('active');
        $('.js-slider-dot-second').addClass('active');
        $('.js-slider-dot-third').removeClass('active');
    });
    $(document).on('click', '.js-slider-number-third', function() {
        $('.b-slider').removeClass('first');
        $('.b-slider').removeClass('second');
        $('.b-slider').addClass('third');
        $('.js-slider-dot-first').removeClass('active');
        $('.js-slider-dot-second').removeClass('active');
        $('.js-slider-dot-third').addClass('active');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/slider-numbers.js